import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { FormattedMessage } from 'react-intl'
import { logoutAndRedirect } from '../../actions/user'
import {
  acceptPolicies,
  hideAcceptPoliciesModal,
  userIsConsideringDecliningPolicies,
  userIsNotConsideringDecliningPolicies
} from '../../actions/policies'
import { decline } from '../../utils/messages'

class AcceptPolicyModal extends Component {
  constructor(props) {
    super(props)
    this.onViewOurPoliciesClickBound = this.onViewOurPoliciesClick.bind(this)
    this.onAgreeClickBound = this.onAgreeClick.bind(this)
    this.onDeclineClickBound = this.onDeclineClick.bind(this)
    this.onYesIAmDecliningClickBound = this.onYesIAmDecliningClick.bind(this)
  }

  render() {
    const { userIsConsideringDecliningPolicies } = this.props
    return (
      <div id="policyAcceptanceModal">
        <div className="policy-acceptance-modal-container">
          {!userIsConsideringDecliningPolicies && (
            <div>
              <p>
                <FormattedMessage
                  id="AcceptPolcicyModal.ByUsing"
                  defaultMessage="By using the OE QuestMaker app, you agree to our policies,
                  including the End User Agreement, Privacy Policy, and
                  the Terms and Conditions."
                />
              </p>
              <div
                className="view-our-policies"
                onClick={this.onViewOurPoliciesClickBound}
              >
                <FormattedMessage
                  id="AcceptPolicyModal.ViewOurPolicies"
                  defaultMessage="View our policies"
                />
              </div>
              <div className="actions">
                <div
                  className="agree button active"
                  onClick={this.onAgreeClickBound}
                >
                  <FormattedMessage
                    id="AcceptPolicyModal.Agree"
                    defaultMessage="AGREE"
                  />
                </div>
                <div className="decline" onClick={this.onDeclineClickBound}>
                  {decline}
                </div>
              </div>
            </div>
          )}
          {userIsConsideringDecliningPolicies && (
            <div>
              <h3>
                <FormattedMessage
                  id="AcceptPolicyModal.AreYouSure"
                  defaultMessage="Are you sure you want to decline?"
                />
              </h3>
              <p>
                <FormattedMessage
                  id="AcceptPolicyModal.ToUse"
                  defaultMessage='To use the OE QuestMaker app, you must agree to these terms. Close this window to review the terms
                  again, or click "Agree to OE Policies" to accept all of the terms now.'
                />
              </p>
              <div className="actions">
                <div
                  className="agree button active"
                  onClick={this.onAgreeClickBound}
                >
                  <FormattedMessage
                    id="AcceptPolicyModal.AgreeToOe"
                    defaultMessage="AGREE TO OE POLICIES"
                  />
                </div>
                <div
                  className="decline"
                  onClick={this.onYesIAmDecliningClickBound}
                >
                  <FormattedMessage
                    id="AcceptPolicyModal.YesIAmDeclining"
                    defaultMessage="YES, I AM DECLINING"
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }

  onViewOurPoliciesClick() {
    this.props.dispatch(hideAcceptPoliciesModal())
    this.props.dispatch(userIsNotConsideringDecliningPolicies())
    this.props.dispatch(push('/policies'))
  }

  onAgreeClick() {
    this.props.dispatch(acceptPolicies())
  }

  onDeclineClick() {
    this.props.dispatch(userIsConsideringDecliningPolicies())
  }

  onYesIAmDecliningClick() {
    this.props.dispatch(logoutAndRedirect())
    this.props.dispatch(hideAcceptPoliciesModal())
    this.props.dispatch(userIsNotConsideringDecliningPolicies())
  }
}

AcceptPolicyModal.propTypes = {
  dispatch: PropTypes.func.isRequired,
  userIsConsideringDecliningPolicies: PropTypes.bool
}

export function mapStateToProps(state) {
  return {
    userIsConsideringDecliningPolicies:
      state.policies.userIsConsideringDecliningPolicies
  }
}

export default connect(mapStateToProps)(AcceptPolicyModal)
export { AcceptPolicyModal as AcceptPolicyModalDisconnected } // pure component - used in tests



// WEBPACK FOOTER //
// ./src/components/modal/AcceptPolicyModal.js